export default "__VITE_ASSET__C15thmXW__"